// Runtime configuration hook - reads synchronously from window.RUNTIME_CONFIG

// Define types for runtime configuration
interface RuntimeConfig {
  API_BASE_URL: string;
}

// Add this to the global Window interface
declare global {
  interface Window {
    RUNTIME_CONFIG?: RuntimeConfig;
  }
}

// Default configuration values
const defaultConfig: RuntimeConfig = {
  API_BASE_URL: "http://localhost:8081", // Default for local development
};

// Read runtime config synchronously to avoid race conditions
function getConfig(): RuntimeConfig {
  if (window.RUNTIME_CONFIG) {
    return { ...defaultConfig, ...window.RUNTIME_CONFIG };
  }
  return defaultConfig;
}

export function useConfig(): RuntimeConfig {
  return getConfig();
}
